import * as React from "react"

export const SearchIndexFrontendConfigContext = React.createContext(undefined)
